'use client';
import { createTheme } from '@mui/material/styles';
import { ptBR } from '@mui/material/locale';

export const theme = createTheme(
  {
    palette: {
      primary: {
        main: '#1B5E3A',
        light: '#2E7D52',
        dark: '#0D3D20',
        contrastText: '#fff',
      },
      secondary: {
        main: '#8D6A1E',
        light: '#B8882A',
        dark: '#614B12',
        contrastText: '#fff',
      },
      background: {
        default: '#F5F5F0',
        paper: '#FFFFFF',
      },
    },
    shape: { borderRadius: 8 },
    typography: {
      fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
      h5: { fontWeight: 700 },
      h6: { fontWeight: 600 },
    },
    components: {
      MuiButton: {
        defaultProps: { disableElevation: true },
        styleOverrides: {
          root: { textTransform: 'none', fontWeight: 600 },
        },
      },
      MuiCard: {
        defaultProps: { elevation: 0 },
        styleOverrides: {
          root: { border: '1px solid #E5E7EB' },
        },
      },
      MuiChip: {
        styleOverrides: { root: { fontWeight: 600 } },
      },
    },
  },
  ptBR
);
